export function logosSlider() {
    const sliderControlBtn = $('.logos-slider-nav  button');

    sliderControlBtn.on('click', function () {
        const $this = $(this);
        if (!$this.hasClass('paused')) {
            $this.addClass('paused');
            $(".logos-slider").addClass('paused');
        } else {
            $this.removeClass('paused');
            $(".logos-slider").removeClass('paused');
        }
    });

    $(".logos-slider").each(function () {
        const isRight = $(this).hasClass("to-right");

        $(this).infiniteslide({
            direction: isRight ? "right" : "left",
            speed: 20,
            pauseonhover: false
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/logosSlider.js